import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API, useAuth, setStoredToken, formatApiError } from "../AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
        if (data.token) setStoredToken(data.token);
        setUser(data.user);
        // Clear hash and go to app
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch (e) {
        setError(formatApiError(e.response?.data?.detail, "Sign-in failed. Please try again."));
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page" data-testid="auth-callback-page">
      <div className="grain-bg" />
      <div className="container-narrow" style={{ textAlign: "center", paddingTop: "30vh" }}>
        <div className="eyebrow shimmer">Signing you in</div>
        {error && <div className="error-msg" data-testid="auth-callback-error" style={{ marginTop: 24 }}>{error}</div>}
      </div>
    </div>
  );
}
